"use client";

import { ReactNode } from "react";
import { csx } from "../utils";

import "./Badge.css";
import { useTheme } from "./ThemeProvider";

export type BadgeVariant =
  | "primary"
  | "secondary"
  | "transparent"
  | "success"
  | "warning"
  | "danger";

export const BadgeVariants: Record<BadgeVariant, BadgeVariant> = {
  primary: "primary",
  secondary: "secondary",
  transparent: "transparent",
  success: "success",
  warning: "warning",
  danger: "danger",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The badge's visual aesthetic.
   */
  variant?: BadgeVariant;
  /**
   * The content to display within the badge.
   */
  children: ReactNode;
}

export const Badge = ({ variant, children, ...props }: BadgeProps) => {
  const { className } = useTheme();
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={props["data-testid"]}
      className={csx(
        "proton-Badge",
        variant && `proton-Badge--${variant}`,
        className
      )}
    >
      {children}
    </div>
  );
};
